import { qq } from 'bobjoll/ts/library/gr/dom.q';

export default async function(form: HTMLFormElement) {
    const fields = (qq('input[required], select[required], textarea[required]', form) as HTMLFormElement[]);

    fields.forEach(field => {
        const fieldErrorElement = field.nextElementSibling && field.nextElementSibling.classList.contains('error') ? field.nextElementSibling : null;

        if (field.checkValidity() && fieldErrorElement && fieldErrorElement.parentElement) {
            field.classList.remove('error');
            fieldErrorElement.parentElement.removeChild(fieldErrorElement);
        } else {
            field.classList.add('error');
            field.insertAdjacentHTML('afterend', `
                <div class="error">${field.validationMessage}</div>
            `);
        }
    });

    if (form.checkValidity()) {
        form.submit();
    }
}

function formDataToObject(form: HTMLFormElement) {
    const formData = new FormData(form);

    var object: { [name: string]: FormDataEntryValue; } = {};

    Array.prototype.slice.call(formData).forEach(function (value: FormDataEntryValue, key: string) {
        object[key] = value;
    });

    return object;
}